import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import { fonts } from 'config/fonts'

const useFonts = (): SelectOption[] => {
  const createSelectOption = (font: string): SelectOption => ({
    label: font,
    value: font.replace(/ /g, '+'),
  })

  return React.useMemo(() => fonts.map(createSelectOption), [])
}

export default useFonts
